import InvitedMembersList from "./InvitedMembersList";
import CloneModal from "./CloneModal";
import { UserAuth } from "../Context";
import Settings from "./Settings";
import CartModal from "../Modals/CartModal";
import useModalStore from "../StatesStore/ModalStore";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  increment,
  updateDoc,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import useFavStore from "../StatesStore/FavStore";
import ListShareMenu from "../components/ListShareMenu";
import { getBaseURL } from "../lib/getBaseURL";
import RenameModal from "./RenameModal";
import useChatClient from "../StatesStore/ChatClient";
import InvitePeople from "./InvitePeople";
const ShopListMore = ({
  list,
  shoppingListData,
  setShoppingListData,
  setLoading,
  BackgroundOnSvg,
  setActiveAccordion,
  showShareButton,
  showInviteButton,
  imageWidth = "32px",
  svgWidth = "15px",
  type,
}) => {
  const { user } = UserAuth();
  const client = useChatClient((state) => state.client);
  const { openModal } = useModalStore();
  const removeFavoriteProduct = useFavStore((state) => state.removeFavorite);
  const favoriteProduct = useFavStore((state) => state.favorites);
  const baseURL = getBaseURL();
  const closeOtherDropdown = () => {
    let dropdowns = document.getElementsByClassName(`Other`);
    dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains(list?.name.split(" ").join(""))) {
        if (dropdown.classList.contains("show")) {
          dropdown.classList.remove("show");
          dropdown.children[0].classList.remove("show");
          dropdown.children[0].ariaExpanded = "false";
          dropdown.children[1].classList.remove("show");
        } else {
          dropdown.classList.add("show");
          dropdown.children[0].classList.add("show");
          dropdown.children[0].ariaExpanded = "true";
          dropdown.children[1].classList.add("show");
        }
      } else {
        dropdown.classList.remove("show");
        dropdown.children[0].classList.remove("show");
        dropdown.children[0].ariaExpanded = "false";
        dropdown.children[1].classList.remove("show");
      }
    });
  };
  const handleClick = () => {
    const DATA = {
      deleteFunction: handleDeleteList,
      displayName: list?.name,
    };
    openModal("ConfirmDelete", "shoppingList", DATA);
  };
  const handleDeleteList = async () => {
    if (!user) return;

    try {
      const selectedShoppingListDoc = doc(
        db,
        "users",
        user?.uid,
        "shoppingList",
        list?.name
      );

      // Get the listId before deleting the shopping list
      const listId = list?.listId;

      if (!listId) throw new Error("ListId not found.");

      // Fetch all member document IDs from the "members" subcollection
      const membersCollectionRef = collection(
        selectedShoppingListDoc,
        "members"
      );
      const membersSnap = await getDocs(membersCollectionRef);
      const memberIds = membersSnap.docs.map((doc) => doc.id);

      // For each member ID, delete the corresponding document from their "invitedList" subcollection
      const deleteInvitedListPromises = memberIds.map(async (memberId) => {
        const invitedListDoc = doc(
          db,
          "users",
          memberId,
          "invitedList",
          listId
        );
        await deleteDoc(invitedListDoc);
        console.log(
          `Deleted listId ${listId} from user ${memberId}'s invitedList`
        );
      });

      await Promise.all(deleteInvitedListPromises);

      console.log("All related documents deleted successfully.");

      // Fetch the product count for the shopping list
      const docCountRef = collection(selectedShoppingListDoc, "products");
      const docCountSnap = await getDocs(docCountRef);
      const countDocs = docCountSnap.size;

      await Promise.all(
        docCountSnap.docs.map(async (doc) => {
          const productRef = doc.ref;
          await deleteDoc(productRef);
        })
      );
      // Remove favorite products
      // eslint-disable-next-line
      favoriteProduct.map((favProd) => {
        removeFavoriteProduct(favProd);
      });
      console.log(favoriteProduct);

      // Update the local state by removing the deleted list
      const remainingLists = shoppingListData?.filter(
        (li) => li?.name !== list?.name
      );

      // Sort the remaining lists by dateCreated in descending order
      remainingLists.sort((a, b) => a.dateCreated - b.dateCreated);

      // Update the local state
      setShoppingListData(remainingLists);

      // Update the user document with the decremented count
      const userRef = doc(db, "users", user?.uid);
      await updateDoc(userRef, {
        shoppingListCount: increment(-countDocs),
      });

      const chatsRef = doc(db, "chats", listId);
      await deleteDoc(chatsRef);
      setActiveAccordion([]);
      console.log("Before client component", client);

      //   try {
      //   if (client) {
      //     // Determine the channel type based on your logic
      //     const channelType = "team"; // or "messaging" - adjust based on your channel type logic
      //     const channel = client.channel(channelType, listId);

      //     // Delete the channel from Stream Chat
      //     await channel.delete();
      //     console.log(`Stream Chat channel ${listId} deleted successfully`);
      //   }
      // } catch (channelError) {
      //   console.error("Error deleting Stream Chat channel:", channelError);
      //   // Don't throw here as we want to continue with the rest of the deletion
      // }
      // Delete the shopping list document
      await deleteDoc(selectedShoppingListDoc);
      console.log("Shopping list deleted successfully");
      console.log("State and Firestore updated successfully.");
    } catch (error) {
      console.error("Error deleting the shopping list:", error.message);
    }
  };
  return (
    <>
      <style jsx>
        {`
          .buttonStyle {
            padding: 10px 16px;
          }
          .buttonStyle:hover {
            backgroundcolor: #e9eaed;
          }
        `}
      </style>
      <div
        onClick={(e) => e.stopPropagation()}
        className={`dropdown ${list?.name?.split(" ")?.join("")} Other`}
      >
        <div
          className={`p-0 dropdown-toggle`}
          role="button"
          id={`${list?.name?.split(" ")?.join("")}Dropdown`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={() => {
            closeOtherDropdown();
          }}
        >
          <div
            style={{
              width: imageWidth,
              height: imageWidth,
            }}
            className="d-flex align-items-center justify-content-end"
          >
            <svg
              style={{
                width: svgWidth,
                height: svgWidth,
              }}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99712 5.83333C9.07662 5.83333 8.33045 5.08714 8.33045 4.16667C8.33046 3.24619 9.07662 2.5 9.99712 2.5C10.9176 2.5 11.6638 3.24619 11.6638 4.16667C11.6638 5.08714 10.9176 5.83333 9.99712 5.83333Z"
                fill="#14191F"
              />
              <path
                d="M10 11.6666C9.07952 11.6666 8.33335 10.9205 8.33335 9.99998C8.33335 9.07948 9.07952 8.33331 10 8.33331C10.9205 8.33331 11.6667 9.07948 11.6667 9.99998C11.6667 10.9205 10.9205 11.6666 10 11.6666Z"
                fill="#14191F"
              />
              <path
                d="M9.99712 17.5C9.07662 17.5 8.33045 16.7538 8.33045 15.8333C8.33046 14.9128 9.07662 14.1666 9.99712 14.1666C10.9176 14.1666 11.6638 14.9128 11.6638 15.8333C11.6638 16.7538 10.9176 17.5 9.99712 17.5Z"
                fill="#14191F"
              />
            </svg>
          </div>
        </div>
        <ul
          className="dropdown-menu dropdown-menu-end mt-0 p-0"
          aria-labelledby={`${list?.name?.split(" ")?.join("")}Dropdown`}
          style={{
            cursor: "pointer",
            fontSize: "18px",
            fontWeight: 500,
            fontFamily: "Inter",
            borderRadius: "16px",
            color: "#667085",
            width: "260px",
            boxShadow: "0px 0px 8px 0px #00000026",
          }}
        >
          <li
            className="buttonStyle"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <CloneModal
              list={list}
              listName={list?.name}
              userId={user?.uid}
              shoppingListData={shoppingListData}
              setShoppingListData={setShoppingListData}
              setLoading={setLoading}
              BackgroundOnSvg={BackgroundOnSvg}
              closeOtherDropdown={closeOtherDropdown}
              disable={list?.products?.length === 0}
            />
          </li>
          {showInviteButton && (
            <li
              className="buttonStyle"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <InvitePeople
                selectedShopList={list}
                listId={list?.listId}
                listName={list?.name}
                myName={user?.displayName}
                listLink={`${baseURL}/#/shoppingList/${list?.listId}/${
                  type === "myList" ? user?.uid : list?.userId
                }`}
                componentName={"shopListMore"}
                BackgroundOnSvg={BackgroundOnSvg}
              />
            </li>
          )}
          {/* Share Button */}
          {showShareButton && (
            <li
              className="buttonStyle"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ListShareMenu
                list={list}
                listName={list?.name}
                myName={user?.displayName}
                listLink={`${baseURL}/#/shoppingList/${list?.listId}/${list?.userId}`}
                listId={list?.listId}
                userId={user?.uid}
                products={list?.products}
                BackgroundOnSvg={BackgroundOnSvg}
                componentName={"shopListMore"}
                closeOtherDropdown={closeOtherDropdown}
              />
            </li>
          )}

          {/* <li className="buttonStyle" onClick={(e) => {e.stopPropagation();}}>
          <CartModal
            listName={list?.name}
            listProducts={list?.products}
            userId={user?.uid}
            BackgroundOnSvg={BackgroundOnSvg}
            closeOtherDropdown={closeOtherDropdown}
          />
        </li> */}
          {type === "myList" && (
            <>
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Settings
                  selectedShopList={list?.name}
                  BackgroundOnSvg={BackgroundOnSvg}
                  closeOtherDropdown={closeOtherDropdown}
                />
              </li>
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <InvitedMembersList
                  listName={list.name}
                  userId={user?.uid}
                  listId={list.listId}
                  BackgroundOnSvg={BackgroundOnSvg}
                  componentName={"shopListMore"}
                  closeOtherDropdown={closeOtherDropdown}
                />
              </li>
              <li
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <RenameModal
                  BackgroundOnSvg={BackgroundOnSvg}
                  list={list}
                  closeOtherDropdown={closeOtherDropdown}
                />
              </li>
              <li
                style={{
                  borderRadius: "0px 0px 16px 16px",
                }}
                className="buttonStyle"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                  onClick={() => {
                    handleClick();
                    closeOtherDropdown();
                  }}
                >
                  <BackgroundOnSvg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.16671 16.6665C4.16671 17.5832 4.91671 18.3332 5.83337 18.3332H14.1667C15.0834 18.3332 15.8334 17.5832 15.8334 16.6665V4.99984H4.16671V16.6665ZM5.83337 6.6665H14.1667V16.6665H5.83337V6.6665ZM13.75 2.49984L12.9167 1.6665H7.08337L6.25004 2.49984H3.33337V4.1665H16.6667V2.49984H13.75ZM10.8334 14.9998V8.33317H12.5V14.9998H10.8334ZM7.50004 8.33317L7.50004 14.9998H9.16671V8.33317H7.50004Z"
                        fill="#FF3742"
                      />
                    </svg>
                  </BackgroundOnSvg>

                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#FF3742",
                    }}
                  >
                    Delete List
                  </span>
                </div>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default ShopListMore;
